import * as variableOverrider from '../../libs/variableOverrider';
import ko from 'knockout';

const variableOverrides = variableOverrider.createOverride(window, { ko });

import 'knockout-fast-foreach/dist/knockout-fast-foreach';

variableOverrides.dispose();
